import { useQuery } from "@tanstack/react-query";
import { getOrphanedSessions } from "../services/get-orphaned-sessions";

export function useOrphanedSessions(bundleUsageId: string | null) {
  return useQuery({
    queryKey: ["orphaned-sessions", bundleUsageId],
    queryFn: () => getOrphanedSessions(bundleUsageId!),
    enabled: !!bundleUsageId,
    staleTime: 1000 * 60 * 5,
  });
}
